import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeStoreService } from 'app/modules/employee/services/employee-store.service';
import { EmployeeService } from 'app/modules/employee/services/employee.service';
import { LeaveService } from 'app/modules/leave/services/leave.service';
import moment from 'moment';
import { Trabajador } from '../types/employee/trabajador.type';

type VoidFunc = () => void;

@Injectable({
    providedIn: 'root',
})
export class RoutingServiceService {
    private _afterMoveTasks: Record<string, VoidFunc> = {};

    constructor(
        private employeeService: EmployeeService,
        private employeeStoreService: EmployeeStoreService,
        private leaveService: LeaveService,
        private router: Router
    ) {}

    /**
     * Add a task to be executed after a navigation
     */
    addAfterRoutingTask(key: string, task: VoidFunc) {
        this._afterMoveTasks[key] = task;
    }

    /**
     * Remove an after move task
     */
    removeRoutingMoveTask(key: string) {
        delete this._afterMoveTasks[key];
    }

    /**
     * Get the after move tasks
     */
    getAfterRotuingTasks(key: string): VoidFunc {
        return this._afterMoveTasks[key];
    }

    /**
     * Select the given employee and move to employee view
     */
    selectEmployee(value: Trabajador) {
        this.employeeService.isEmployeeDeleted = false;
        this.employeeService.currentEmployeeId = value.trabajadorId;
        this.employeeService.currentEmployee = value;
        this.employeeStoreService.employee = value;
        this.employeeService.getemployeeID(value.trabajadorId);
        localStorage.setItem('EmplooyeeID', value.trabajadorId.toString());
        localStorage.setItem('EmplooyeeData', JSON.stringify(value));
        this.employeeService
            .getEmployeeDetails(value.trabajadorId)
            .subscribe((res) => {
                let response: any;
                response = res;
                let fristdate: any;
                let seconddate: any;
                let formattedToday: any;
                const resultArray = response.result;
                if (response.result) {
                    for (let i = 0; i < resultArray.length; i++) {
                        if (resultArray[i].Fbaja !== null) {
                            fristdate = moment(
                                resultArray[i].Fbaja.split('T')[0]
                            );
                        }
                        if (resultArray[i].Falta !== null) {
                            seconddate = moment(
                                resultArray[i].Falta.split('T')[0]
                            );
                            const DateDiff = moment
                                .duration(seconddate.diff(fristdate))
                                .asDays();
                            resultArray[i].Dias = DateDiff + 1;
                        } else {
                            formattedToday = moment(new Date());
                            const DateDiff = moment
                                .duration(formattedToday.diff(fristdate))
                                .asDays();
                            resultArray[i].Dias = DateDiff + 1;
                        }

                        if (i + 1 === resultArray.length) {
                            this.employeeService.bajas = response.result;
                            if (response.result.length > 0) {
                                this.leaveService.SelectedRowId =
                                    response.result[0].id;
                            }
                        }
                    }

                    this.employeeStoreService.initEmployee();
                }
            });
        this.employeeService.getheaderDetails(value.trabajadorId).subscribe();
        this.employeeService.getTrabajador(value.trabajadorId);

        localStorage.removeItem('LeaveID');
        this.leaveService.SelectedRowId = 0;

        if (this.router.url.includes('/employee'))
            this.router.navigate(['/temp']);
        setTimeout(
            () =>
                this.router.navigate(['/employee'], {
                    replaceUrl: this.router.url.includes('/temp'),
                }),
            10
        );
    }
}
